<template>
  <div>
    <Title :title="'电池质保'" :isActiveSec="true"></Title>
    <div class="flex">
      <div class="barrery-inner text-center" v-for="(item,index) in batterysNumList" :key="index">
        <img src="@/assets/images/index/battery_icon.png"/>
        <div class="price text-df">{{item.counts}}<span class="text-12">个</span></div>
        <div class="count text-12">{{item.texts}}</div>
      </div>
      <Pie :cdata="cdata" :width="style.width" :height="style.height"/>
    </div>
  </div>
</template>

<script>
import Pie from '../pie'
import Title from '../../title.vue'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      cdata: {
        id:"loadRatePie",
        data: [
          {value: 0, name: '80%'},
          {value: 0, name: '60%'},
          {value: 0, name: '40%'},
          {value: 0, name: '20%'},
        ],
      },
      batterysNumList:[{texts:'当前商用车电池数',counts:''},{texts:'当前乘用车电池数',counts:''}],
      style:{
        width: '300',
        height: '180'
      }
    };
  },
  components: {
    Pie,
    Title
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectBatterysQA(data);
      this.selectBatterysQAPie(data);
    },
    selectBatterysQA(data={}){
      let _this = this;
      let params = {};
			if(data){
				//电池质保--省市区
				params = {
					"enCode":"TiDB-shengshiqu-dianchizhibao",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-dianchizhibao"//全国
				}
			}

      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          console.log('电池质保',res)
          this.batterysNumList[0].counts = res.syBatterysNum||0;//商用电池数
          this.batterysNumList[1].counts = res.cyBatterysNum||0;//乘用电池数
          // this.$set(batterysNumList.counts,0,res.syBatterysNum);//商用电池数
          // this.$set(batterysNumList.counts,1,res.cyBatterysNum);//乘用电池数
        })
        .catch((err) => {
          console.log(err);
        });

    }, 
    selectBatterysQAPie(data={}){
      let _this = this;
      let params = {};
			if(data){
				//电池质保--省市区
				params = {
					"enCode":"TiDB-shengshiqu-dianchizhibaotu",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-dianchizhibaotu"//全国
				}
			}

      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          console.log('电池质保',res)
          this.cdata.data = res;
        })
        .catch((err) => {
          console.log(err);
        });

    }, 
  }
};
</script>

<style lang="scss" scoped>

.barrery-inner{
  // margin-right:12px;
  width: 94px;
  padding: 0 9px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  img{
    width:30px;
    height:30px;
  }
  .price{

  }
  .count{

  }
}
</style>